module.exports = __webpack_public_path__ + "img/qrcode_for_gh_d89d6b461c06_430.d5e4674d.jpg";